import React from 'react';
import { FileText, Send, Eye, PenLine, Hourglass, BadgeCheck } from 'lucide-react';
import { fmtEUR } from './api';

const Tile = ({ icon: Icon, label, value, sub, cls, testId }) => (
  <div className={`rounded-xl border p-4 ${cls}`} data-testid={testId}>
    <div className="flex items-center gap-2 text-xs font-medium opacity-80"><Icon className="h-4 w-4" /> {label}</div>
    <p className="text-2xl font-bold mt-1">{value}</p>
    {sub && <p className="text-[11px] opacity-70 mt-0.5">{sub}</p>}
  </div>
);

export const DevisDashboard = ({ stats }) => {
  if (!stats) return null;
  return (
    <section className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3" data-testid="ia-devis-dashboard">
      <Tile icon={FileText} label="Devis générés" value={stats.generes} sub={`${stats.sessions} session(s)`} cls="bg-white border-slate-200 text-slate-800" testId="ia-dash-generes" />
      <Tile icon={Send} label="Envoyés" value={stats.envoyes_total} sub={`${stats.non_envoye} non envoyé(s)`} cls="bg-amber-50 border-amber-200 text-amber-900" testId="ia-dash-envoyes" />
      <Tile icon={Eye} label="Ouverts" value={stats.ouvert + stats.signe} sub={`Taux d'ouverture ${stats.taux_ouverture} %`} cls="bg-sky-50 border-sky-200 text-sky-900" testId="ia-dash-ouverts" />
      <Tile icon={PenLine} label="Signés" value={stats.signe} sub={`Taux de signature ${stats.taux_signature} %`} cls="bg-emerald-50 border-emerald-200 text-emerald-900" testId="ia-dash-signes" />
      <Tile icon={Hourglass} label="Montant en attente" value={fmtEUR(stats.montant_en_attente_ttc)} sub="TTC, devis non signés" cls="bg-violet-50 border-violet-200 text-violet-900" testId="ia-dash-attente" />
      <Tile icon={BadgeCheck} label="Montant signé" value={fmtEUR(stats.montant_signe_ttc)} sub={`TTC · ${stats.payes} payé(s) · encaissé ${fmtEUR(stats.montant_encaisse_ttc)}`} cls="bg-emerald-600 border-emerald-600 text-white" testId="ia-dash-signe-montant" />
    </section>
  );
};
